/* src/app/modules/file/upload-file.component.css */
:host {
  --ud-primary: var(--cf-brand-dark, #d48f00);
  --ud-primary-bg: rgba(212, 143, 0, 0.10);
  --ud-danger: #e03131;
  --ud-muted: #868e96;
  --ud-border: #dee2e6;
  --ud-radius: 10px;
}
.ud-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 24px 0;
  position: relative;
}
.ud-header__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--ud-primary-bg);
  flex-shrink: 0;
}
.ud-header__icon-wrap mat-icon {
  color: var(--ud-primary);
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.ud-header__title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 17px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}
.ud-header__sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--ud-muted);
}
.ud-close {
  position: absolute !important;
  top: 16px;
  right: 16px;
  color: var(--ud-muted) !important;
}
.ud-content {
  padding: 16px 24px 8px !important;
  min-width: 440px;
}
.ud-dropzone {
  border: 2px dashed var(--ud-border);
  border-radius: var(--ud-radius);
  padding: 36px 24px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  background: #fafafa;
}
.ud-dropzone:hover {
  border-color: var(--ud-primary);
  background: rgba(255, 152, 0, 0.04);
}
.ud-dropzone__icon {
  font-size: 44px;
  width: 44px;
  height: 44px;
  color: var(--ud-primary);
  margin-bottom: 8px;
}
.ud-dropzone__main {
  margin: 0;
  font-weight: 600;
  font-size: 15px;
  color: #333;
}
.ud-dropzone__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--ud-muted);
}
.ud-files {
  margin-top: 16px;
  border: 1px solid var(--ud-border);
  border-radius: var(--ud-radius);
  overflow: hidden;
}
.ud-file {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #f2f2f2;
}
.ud-file:last-child {
  border-bottom: none;
}
.ud-file__icon {
  color: var(--ud-muted);
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.ud-file__name {
  flex: 1;
  font-size: 13px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ud-file__del {
  color: var(--ud-muted) !important;
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
  flex-shrink: 0;
}
.ud-file__del mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ud-messages {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ud-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f8f9fa;
  font-size: 13px;
  color: #555;
}
.ud-message mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--ud-primary);
  margin-top: 1px;
}
.ud-actions {
  padding: 8px 24px 20px !important;
  justify-content: flex-end !important;
}
.ud-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
  gap: 20px;
}
.ud-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: var(--ud-primary-bg);
}
.ud-loading__icon-wrap mat-icon {
  font-size: 30px;
  width: 30px;
  height: 30px;
  color: var(--ud-primary);
}
.ud-loading__dots {
  display: flex;
  gap: 8px;
}
.ud-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ud-primary);
  opacity: 0.3;
  animation: ud-pulse 1.2s ease-in-out infinite;
}
.ud-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.ud-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.ud-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--ud-muted);
}
@keyframes ud-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
/*# sourceMappingURL=upload-file.component.css.map */
